import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

export type OnboardingTaskRow = {
  id: string;
  partner_id: string;
  title: string;
  description: string | null;
  due_date: string | null;
  status: string;
  assigned_to_partner: boolean;
  completed_at: string | null;
  created_at: string;
};

// GET /api/partners/:id/onboarding — partner-detail Onboarding tab list.
export function useOnboardingTasks(partnerId: string | undefined) {
  return useQuery<OnboardingTaskRow[], ApiClientError>({
    queryKey: queryKeys.partners.onboarding(partnerId ?? ""),
    queryFn: () => apiFetch<OnboardingTaskRow[]>(`/partners/${partnerId}/onboarding`),
    enabled: !!partnerId,
  });
}
